module.exports = __webpack_public_path__ + "static/media/logo.f1999632.png";